// 푸터 회사정보. 데스크톱(home2/FooterSection) · 모바일(home2/FooterSectionMobile)이 같이 쓴다.
//
// 회사명 · 사업자번호는 2026-10-15 지시로 AURA · 573-81-03483 이다(CLAUDE.md §4 '푸터 폭은 헤더와 같다').
// 시안(데스크톱 · 모바일 모두)에는 옛 값(REALGOLD/GOLDNARA · 608-81-65669)이 적혀 있으니
// 시안을 다시 뽑아도 여기를 따른다. 바꿀 때는 이 파일 하나만 고치면 두 푸터가 같이 바뀐다.
//
// 각 줄은 [앞말, 뒷말 …] 이고 사이에 세로 구분자가 들어간다.
export const FOOTER_INFO_LEFT = [
  ['AURA', 'CEO', '배재한'],
  ['Business Registration No.', '573-81-03483'],
  ['Email', 'goldnara4@gmail.com'],
]

export const FOOTER_INFO_RIGHT = [
  ['Address', '서울 종로구 돈화문로5가길 1 피카디리플러스 7층 701호'],
  ['골드나라 배재한의 금토크', '경남 창원시 성산구 원이대로 320 시티세븐 W145'],
  ['Number', '1833-5977'],
]

// 설명문 두 줄.
export const FOOTER_LEAD = [
  '실물 금 자산 거래부터 미디어, 기업 협력,실시간 거래 플랫폼까지',
  '골드나라의 주요 서비스를 확인해보세요.',
]

export const FOOTER_COPYRIGHT = 'Copyright © AURA. All rights reserved.'
